import React, { useMemo, useState, useEffect } from 'react';
import { Goal, MoveRight, Package, Wallet, MoreHorizontal, Search, Eye, FileEdit, Trash2 } from "lucide-react";
import TableContainer from 'Common/TableContainer';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Dropdown } from 'Common/Components/Dropdown';
import filterDataBySearch from 'Common/filterDataBySearch';





const OverviewTabs = ({ transactions, user }: any) => {
    const dispatch = useDispatch();

    const [originalData, setOriginalData] = useState<any[]>([]);
    const [data, setData] = useState<any[]>([]);

    const [userData, setUserData] = useState<any[]>([]);

    useEffect(() => {
        if (transactions && Array.isArray(transactions)) {
            const mapped = transactions.map((item: any) => ({
                transactionId: item.transactionId,
                userId: item.userId,
                receiver: item.receiver,
                mobile: item.mobile,
                amount: item.amount,
                fixrate: item.fixrate,
                expense: item.expense,
                commission: item.commission,
                usdt: item.usdt,
                deliveryTime: item.deliveryTime,
                comments: item.comments,
                token: item.token,
                transferCharge: item.transferCharge,
                status: item.status,
                groupName: item.groupName,
            }));
            setOriginalData(mapped);  // store the full data
            setData(mapped);          // show initially
        }
    }, [transactions]);

    useEffect(() => {
        if (user && Array.isArray(user)) {
            const mapped = user.map((item: any, index: number) => ({


            }));
            setUserData(mapped);
        }
    }, [transactions]);



    const filterSearchData = (e: any) => {
        const search = e.target.value;
        const keysToSearch = ['transactionId', 'receiver', 'status', 'token', 'deliveryTime'];
        filterDataBySearch(originalData, search, keysToSearch, setData);
    };


    const columns = useMemo(() => [


        {
            header: "Receiver",
            accessorKey: "receiver",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Delivery Time",
            accessorKey: "deliveryTime",
            enableColumnFilter: false,
            enableSorting: true,
             cell: (info: any) => new Date(info.getValue() as any).toLocaleString("en-US", {
                day: "2-digit", month: "short", year: "numeric",
            }),
        },
        {
            header: "Token",
            accessorKey: "token",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Comments",
            accessorKey: "comments",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Fix Rate",
            accessorKey: "fixrate",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Expense",
            accessorKey: "expense",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Commission",
            accessorKey: "commission",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "USDT",
            accessorKey: "usdt",
            enableColumnFilter: false,
            enableSorting: true,
        },

        {
            header: "Status",
            accessorKey: "status",
            enableColumnFilter: false,
            enableSorting: true,
            cell: (cell: any) => {
                const status = cell.row.original.status;
                const statusMap: any = {
                    closed: 'red',
                    pending: 'yellow',
                };
                const color = statusMap[status];
                return (
                    <span className={`text-black delivery_status px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-${color}-200 border-${color}-200 text-${color}-500 dark:bg-${color}-500/20 dark:border-${color}-500/20`}>
                        {status}
                    </span>
                );
            },
        },

    ], [data]);
    return (
        <React.Fragment>
            <div className="grid grid-cols-1 gap-x-5 2xl:grid-cols-12">
                <div className=" col-span-12 card">

                    <div className="card-body ">
                        <div className="grid items-center grid-cols-9 gap-3 mb-5   ">
                            <div className=" col-span-5  ">
                                <h6 className="text-15">Transaction History</h6>
                            </div>
                            <div className=" col-span-4    ">
                                <div className="flex gap-3">
                                    <div className="relative grow ">
                                        <input type="text" className="form-input dark:bg-zink-500 dark:border-zink-400" placeholder="Search for ...  " onChange={filterSearchData} />
                                    </div>
                                    <button type="button" className="btn bg-custom-500 text-white">
                                        <i className="ri-download-2-line pr-1"></i> Export
                                    </button>
                                </div>
                            </div>
                        </div>
                        <TableContainer
                            isPagination={true}
                            columns={columns}
                            data={data}
                            customPageSize={7}
                            divclassName="overflow-x-auto"
                            tableclassName="w-full whitespace-nowrap"
                            theadclassName="ltr:text-left rtl:text-right bg-slate-100 text-slate-500 dark:text-zink-200 dark:bg-zink-600"
                            thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-y border-slate-200 dark:border-zink-500"
                            tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
                            PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
                        />
                    </div>
                </div>

            </div>

        </React.Fragment>
    );
}

export default OverviewTabs;